// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Sector.View'
    , [
        'calculator_square_foot_sector.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_sector_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_sector_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-sector"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var radius = $('#square-foot-sector-radius').val(),
                    angle = $('#square-foot-sector-angle').val();
                //output fields
                var area = $('#square-foot-sector-area');

                var z = (parseFloat(angle) * Math.PI) / 360;
                var x = parseFloat(z) * (parseFloat(radius) * parseFloat(radius));

                area.val(x.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-sector-input-fields').find('input:text').val('');
                $('.calculator-square-foot-sector-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
